import { Injectable } from '@angular/core';

import { BaseService } from './base.service';

import { Destination } from '../../objects/destination';
import { Product } from '../../objects/product';
import { InventoryUnit } from 'src/objects/inventory-unit';
import { DateOfStay } from 'src/objects/date-of-stay';
import { map } from 'rxjs/operators';
import { format } from 'date-fns';

@Injectable({
  providedIn: 'root'
})
export class InventoryService extends BaseService {
  createInstance = (attributes: InventoryUnit) => attributes;

  /**
   * IMPORTANT: Quantity on UI is limited to 20, so we do want to
   * limit no of pages to 1 page only with results limit set accordingly
   *
   * @param payload destination and product w/ optional date range
   * @returns InventoryUnit[]
   */
  getAll(payload: { destination: Destination; product: Product; dateOfStay: DateOfStay | null }) {
    const url = `${ this.baseUrl }/public/available_inventory/`;
    const {
      destination,
      product,
      dateOfStay,
    } = payload;

    let params = {
      ['destination_id']: destination.id.toString(),
      ['product_id']: product.id.toString(),
    } as any;

    if (!!dateOfStay && dateOfStay.isStartAndEndSet()) {
      params['start_date'] = format(dateOfStay.start!, 'yyyy-MM-dd')
      params['end_date'] = format(dateOfStay.end!, 'yyyy-MM-dd')
    }

    const mapTo = (attributes: InventoryUnit) => attributes as InventoryUnit;

    return this
      .getPage<InventoryUnit, InventoryUnit>({
        url,
        params,
        mapTo,
        limit: 20,
        page: 1,
      })
      .pipe(map(({ results }) => results));
  }
}
